export default "__VITE_ASSET__DD44eFjc__"